import { createContext } from 'react';

const AlertContext = createContext({
  alerts: [],
  // eslint-disable-next-line no-unused-vars
  addAlert: (message) => {},
  // eslint-disable-next-line no-unused-vars
  addSuccessAlert: (message) => {},
  // eslint-disable-next-line no-unused-vars
  addErrorAlert: (message) => {}
});

export default AlertContext;
